import React from 'react'
import '../styles/App.css';
// import plane from '../static/images/plane.svg'
import ThreeScene from '../components/content/LighterBlender';
import { faArrowLeft, faArrowRight, faHandPointer } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Home() {
    return (
        <div className='container container-page'>
            <div className='container container-hero-image'>
                {/* <img className='hero-image' src={plane}/> */}
                <ThreeScene />
            </div>
            <div className='floating-hero-desc'>
                <FontAwesomeIcon icon={faArrowLeft} />
                <FontAwesomeIcon icon={faHandPointer} />
                <FontAwesomeIcon icon={faArrowRight} />
            </div>
        </div>
    );
}

export default Home;